import { render, staticRenderFns } from "./DiscussionForumComment.vue?vue&type=template&id=cf2eeed8&scoped=true&"
import script from "./DiscussionForumComment.vue?vue&type=script&lang=js&"
export * from "./DiscussionForumComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2eeed8",
  null
  
)

export default component.exports